import * as React from 'react'
import { DisplayContent } from 'react-content-engine'

import Box, { BoxType } from 'components/Box'
import Heading from 'components/Heading'
import Section, { SectionType } from 'components/Section/Section'
import Flipclock from '../../../elements/Flipclock'

interface CountdownProps {
  timestamp: string | Date
  pattern: string
}

const Countdown: React.FC<CountdownProps> = ({ timestamp, pattern }) => {
  return (
    <Section type={SectionType.solid}>
      <Box type={BoxType.pattern} patternImage={pattern}>
        <Heading
          level={3}
          subHeading={
            <DisplayContent contentKey="box-sub-heading">
              I will be fast
            </DisplayContent>
          }
        >
          <DisplayContent contentKey="box-heading">
            For you the knowledge is the way
          </DisplayContent>
        </Heading>
        <p>
          <DisplayContent contentKey="box-blurb">
            This citytrip is only available for a short amount of time. So short
            that you probably couldn't find 147 other people similar to you. So
            this is a great opportunity to try this distinct flavour. What are
            you waiting?
          </DisplayContent>
        </p>
        <Flipclock timestamp={timestamp} />
      </Box>
    </Section>
  )
}

export default Countdown
